import { Box } from '@mui/material';
import { forwardRef, type ReactNode } from 'react';

/**
 * The sunken, bordered box that holds one dataset and the rows under it. A
 * `selected` box, the one the user works on, has a teal border.
 */
const DatasetBox = forwardRef<
    HTMLDivElement,
    {
        selected?: boolean;
        children: ReactNode;
        'data-testid'?: string;
    }
>(function DatasetBox(
    { selected = false, children, 'data-testid': testId },
    ref
) {
    return (
        <Box
            ref={ref}
            display="flex"
            flexDirection="column"
            overflow="hidden"
            data-testid={testId}
            sx={(theme) => ({
                border: `1px solid ${
                    selected
                        ? theme.palette.primary.main
                        : theme.palette.divider
                }`,
                borderRadius: `${theme.shape.borderRadius}px`,
                backgroundColor: theme.palette.background.sunken,
            })}
        >
            {children}
        </Box>
    );
});

export default DatasetBox;
